import { BrandLoader } from "@/components/BrandLoader";

export function FullPageLoader({ message }: { message?: string }) {
  return (
    <div
      className="full-page-loader fixed bottom-0 right-0 top-0 z-40 flex flex-col items-center justify-center gap-3 p-4 text-center"
      style={{ left: "var(--full-page-loader-left, 0px)", background: "#f5ead8" }}
      role="status"
      aria-live="polite"
    >
      <BrandLoader label={message ?? "Loading"} width={260} />
    </div>
  );
}
